module.exports = __webpack_public_path__ + "static/digitalNotification3-e5241c16af8dd4b4a52cbed159ff9559.png";